const year = new Date().getFullYear();
const ar = {
  header: {
    about: "حول",
    contact: "اتصل",
    pricing: "التسعير",
    ReportAbuse: "الإبلاغ عن إساءة",
    InvitationSystem: "نظام الدعوة",
    verify_email: "تحقق من البريد الإلكتروني",
    sign_in: "تسجيل الدخول",
    dashboard: "لوحة القيادة",
    biolink_page: "صفحة بيولينك",
    admin: "مسؤل",
    logout: "تسجيل خروج",
    sign_up: "اشتراك",
    about_us: "معلومات عنا",
    name:'دانييل جونز',
    post:'الرئيس التنفيذي والمؤسس',
    contact_us: "اتصل بنا",
    payments_list: "قائمة المدفوعات",
  },

  footer: {
    terms_conditions: "الأحكام والشروط ",
    privacy_policy: "سياسة الخصوصية",
    copyright: "حقوق الطبع والنشر © " + year + " bil.bio",
    Update_cookies_preferences: "إدارة ملفات تعريف الارتباط",
  },

  contact: {
    name_required: "مطلوب اسم",
    only_alphabets: "يسمح فقط الحروف الهجائية لهذا المجال",
    more_characters: "لا يمكن أن يزيد الاسم عن 20 حرفًا.",
    valid: "يجب أن يكون البريد الإلكتروني صالحًا",
    subject: "الموضوع مطلوب",
    subject_max: "لا يمكن أن يزيد الموضوع عن 30 حرفًا.",
    message: "الرسالة مطلوبة ",
    message_min: "يجب ألا يقل طول الرسالة عن 40 حرفًا.",
    message_max: "لا يمكن أن تزيد الرسالة عن 250 حرفًا.",
  },
  auth: {
    create_your_account: "أنشئ حسابك",
    signup_to_bilbio_and_create_your_biolink_now:
      "قم بالتسجيل في bilbio وقم بإنشاء Biolink الخاص بك الآن!",
    pagename: "اسم الصفحة",
    enter_page_name: "أدخل اسم الصفحة",
    enter_page_email: "أدخل عنوان البريد الإلكتروني",
    by_creating_an_account_you_agreeing_to_our:
      "من خلال إنشاء حساب ، فإنك توافق على",
    log_in: "تسجيل الدخول",
    create_account: "إنشاء حساب",
    hi_welcome_back: "مرحبًا بك مرة أخرى!",
    enter_you_details_to_login_into_your_bilbio_account:
      "أدخل التفاصيل الخاصة بك لتسجيل الدخول إلى حساب bilbio الخاص بك",
    enter_password: "أدخل كلمة المرور",
    login: "تسجيل الدخول",
    sign_up: "اشتراك",
    do_not_have_an_account: "ليس لديك حساب؟",
    page_name_required: "اسم الصفحة مطلوب",
    pass_required: "كلمة المرور مطلوبة",
    this_username_is_already_taken: "الاسم مستخدم من قبل",
    page_name_cannot_contain_symbols: "لا يمكن أن يحتوي اسم الصفحة على رموز",
    forgot_your_password: "نسيت كلمة السر",
  },

  Invitation_System: {
    More_than_a_todo_app: "أكثر من تطبيق لإدارة المهام",
    paragraph:
      "لوريم إيبسوم دولور سيت آميت، كونسيكتيتور أديبيسيبينغ إيليت. إمبيديت كوام إيوم فاكير إكسبليكابو، دولوروم سيد كونسيكونتور إنكيديونت، كولبا كوم فولوبتاتيم، إياكوي كونسيكتيتور سايبي ريروم دولور؟ كوم إيوس لابوري ديبيتيس مينوس",
    thanks_for_siging: "شكرا لك على تسجيل الدخول",
    verify_your_email: "قم بتأكيد بريدك الألكتروني",
    confirm_email: "يرجى تأكيد رغبتك في استخدام هذا كعنوان بريدك الإلكتروني",
    verify_email: "التحقق من البريد الإلكتروني",
    bilbio_Account_activated: "تم تفعيل حساب الفاتورة الحيوية",
    hello: "أهلا جون",
    email_verified:
      "شكرا لك، لقد تم التحقق من بريدك الإلكتروني. حسابك هو  نشط الان",
    link_login_account:
      "الرجاء استخدام هذا الرابط أدناه لتسجيل الدخول إلى حسابك",
    login_Account: "تسجيل الدخول",
    invite_friend: "دعوة صديق",
    invite_friend_cap: "دعوة صديق",
    you_have: "لديك",
    credits: "ائتمان",
    friend: "صديق",
    sent: "مرسل",
    login_Account: "تسجيل الدخول",
    invite_friend: "دعوة صديق",
    invite_friend_cap: "دعوة صديق",
    you_have: "لديك",
    credits: "ائتمان",
    friend: "صديق",
    sent: "مرسل",
    invite_success: "تم إرسال الدعوات بنجاح.",
    invite_failed: "حدث خطأ أثناء إرسال الدعوة.",
    invite_resend: "إعادة إرسال الدعوة",
  },
  front_end_pages: {
    home_page: {
      hero_section: {
        main_title: "فعل كل شيء مع واحد",
        main_title_br: "برنامج",
        sub_title:
          ".قم بتقصير عناوين URL وإنشاء صفحات الارتباط الحيوي ورموز QR المخصصة وروابط vcard وروابط الملفات والمزيد",
      },
      features_section: {
        biolink: "بيولينك",
        create: "إنشاء",
        create_your: "قم بإنشاء",
        unique: "الفريد",
        sec_one_first_line:
          "قم بإنشاء صفحة الارتباط المخصصة الخاصة بك بسهولة في غضون ثوان",
        sec_one_sec_line: "توحيد تواجدك على الإنترنت بالكامل في ارتباط واحد.",
        sec_one_thired_line: "رابط واحد لمشاركة كل شيء مع متابعيك.",
        sec_one_four_line:
          "قم بإضفاء الطابع الشخصي على الروابط البيولوجية الخاصة بك ، واجعلها قصيرة ونقية وأسهل للمشاركة.",
        customize: "تخصيص",
        design: "تصميم",
        exceptional: "استثنائي",
        sec_two_first_line:
          ".قم بإنشاء صفحة الارتباط الحيوي الفريدة والقابلة للتخصيص بدرجة كبيرة بسهولة",
        sec_two_sec_line:
          "إضفاء الطابع الشخصي على biolink الخاص بك مع الألوان والعلامات التجارية المخصصة.",
        sec_two_thired_line:
          "أصبحت التجربة أسهل مع العديد من المكونات الجاهزة للاستخدام.",
        sec_two_four_line:
          "أضف Instagram و Twitter و Snapchat و تيك توك و Youtube ومقابض الوسائط الاجتماعية والصور والمزيد.",
        share: "شارك",
        add_your_biolink_to_your: " أضف بيولينك إلى ملف",
        social_media: "وسائل التواصل الاجتماعي",
        handles: "مقابض ",
        sec_thered_first_line:
          "أضف عنوان URL الخاص بـ biobil المخصص إلى جميع الأنظمة الأساسية للوصول إلى جمهورك.",
        sec_thered_sec_line:
          "إضفاء الطابع الشخصي على biolink الخاص بك مع الألوان والعلامات التجارية المخصصة.",
        sec_thered_thired_line:
          "أصبحت التجربة أسهل مع العديد من المكونات الجاهزة للاستخدام.",
        sec_thered_four_line: "أضف العلامة التجارية وتحسين محركات البحث.",
      },
      pricing_section: {
        subscription: "الاشتراك",
        choose_a: "اختر أ",
        plan: "يخطط",
        that_works_for_you: "هذا يناسبك ",
        monthly: "شهريا",
        annual: "سنوي",
        what_included: "ما يحتويه",
        unlimited_biolink_pages: "صفحات بيولينك غير محدودة ",
        unlimited_biolink_blocks: "كتل بيولينك غير محدودة",
        bio_pages: "25 صفحة بيولينك",
        seo_feature: "ميزات تحسين محركات البحث",
        brandings: "العلامات التجارية",
        customer_support: "24 * 7 دعم العملاء",
      },
      create_page_section: {
        bilbio: "بلباو",
        start_creating_your_exclusive: "ابدأ في إنشاء ملفات",
        start_creating_your_exclusive_bilbio: "ابدأ في إنشاء بلباو الخاص بك",
        biolink_url: "رابط بيولينك",
        now: "الآن",
      },
    },
    about: {
      description_text:
        "لوريم إيبسوم هو ببساطة نص شكلي للطباعة و صناعة التنضيد. كان لوريم إيبسوم هو الصناعة نص وهمي قياسي منذ 1500 ثانية ، عندما كان مجهولاً أخذت الطابعة لوحًا من النوع وتدافعت عليه لصنع ملف اكتب كتاب العينة. لم ينج سوى خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، بقيت دون تغيير جوهريًا1960 ق مع إصدار أوراق Letraset التي تحتوي على لوريم إيبسوم.",
      description_text_mobile:
        "لوريم إيبسوم هو ببساطة نص شكلي في صناعة الطباعة والتنضيد. كان لوريم إيبسوم هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا.",
      team: "فريق",
      meet_our_amazing: "تلبية لدينا مذهلة",
      view_all: "مشاهدة الكل",
      get_in_touch: "ابقى على تواصل",
    },
    contact: {
      fill_up_your_contact: "املأ بيانات الاتصال الخاصة بك",
      information_and_our_team: "المعلومات وفريقنا",
      will_get_back_to_you: "سوف نعود اليك.",
      enter_first_name: "أدخل الاسم الأول",
      enter_last_name: "إدخال اسم آخر",
      enter_phone_number: "أدخل رقم الهاتف",
      enter_email: "أدخل عنوان البريد الالكتروني",
      enter_message_here: "أدخل الرسالة هنا",
      last_name: "اسم العائلة",
      phone_number: "رقم التليفون",
      enter_valid_number: "أدخل رقمًا صالحًا",
      message: "رسالة",
      last_name_required: "نشاط اسم مطلوب",
      phone_number_required: "رقم الهاتف مطلوب",
      the_email_should_have_less_then_characters:
        "يجب أن يكون البريد الإلكتروني أقل من 50 حرفًا",
      message_required: "حقل الرسالة مطلوب",
    },
    pricing: {
      simple_plans_for: "خطط بسيطة ل",
      everyone: "الجميع",
      have_a_coupon: "هل لديك قسيمة؟",
      choose_your_plan_get_amazing_discounts_cancel_anytime:
        "اختر خطتك. احصل على خصومات مذهلة. يمكنك الإلغاء في أي وقت.",
      free_plan: "خطة مجانية",
      premium_plan_paid: "الخطة المميزة (المدفوعة)",
    },
    privacy_policy: {
      lorem_ipsum_is_simply_dummy_text_of_the_printing:
        "لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد.",
      lorem_ipsum_has_been_the_industry_standard_dummy_text:
        "لوريم إيبسوم هو النص الوهمي القياسي في الصناعة.",
      what_is_lorem_ipsum: "ما هو لوريم إيبسوم؟",
      first_para:
        "لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان لوريم إيبسوم هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع لوريم إيبسوم ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات لوريم إيبسوم.",
      second_para:
        "لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان لوريم إيبسوم هو النص الوهمي القياسي في هذه الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات بإصدار أوراق Letraset التي تحتوي على لوريم إيبسوم",
      li_one:
        "خلافًا للاعتقاد الشائع ، فإن لوريم إيبسوم ليس مجرد نص عشوائي. لها جذور في قطعة من الأدب اللاتيني الكلاسيكي من 45 قبل الميلاد ، مما يجعلها أكثر من 2000 عام.",
      li_two:
        "قام ريتشارد مكلينتوك ، الأستاذ اللاتيني في كلية هامبدن سيدني في فيرجينيا ، بالبحث عن واحدة من أكثر الكلمات اللاتينية غموضًا ، consectetur ، من مقطع لوريم إيبسوم ، وتصفح اقتباسات الكلمة في الأدب الكلاسيكي ، اكتشف المصدر الذي لا شك فيه.",
      li_three:
        'يأتي لوريم إيبسوم من الأقسام 1.10.32 و 1.10.33 من "de Finibus Bonorum et Malorum" (أقصى الخير والشر) بقلم شيشرون ، الذي كتبه عام 45 قبل الميلاد.',
      li_four:
        'هذا الكتاب عبارة عن أطروحة حول نظرية الأخلاق ، وقد حظيت بشعبية كبيرة خلال عصر النهضة. السطر الأول من لوريم إيبسوم ، "لوريم إيبسوم dolor sit amet .." ، يأتي من سطر في القسم 1.10.32.',
      why_do_we_use_it: "لماذا نستخدمه؟",
      last_para:
        "هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل توضع الفقرات في الصفحة التي يقرأها. الهدف من استخدام لوريم إيبسوم هو أنه يحتوي على توزيع طبيعي -إلى حد ما- للأحرف ، بدلاً من استخدام ، مما يجعلها تبدو وكأنها إنجليزية قابلة للقراءة. تستخدم العديد من حزم النشر المكتبي ومحرري صفحات الويب الآن  كنص نموذج افتراضي ، وسيكشف البحث عن عن العديد من مواقع الويب التي لا تزال في مهدها. تطورت إصدارات مختلفة على مر السنين ، أحيانًا عن طريق الصدفة ، وأحيانًا عن قصد (روح الدعابة المحقونة وما شابه ذلك).",
    },
  },
  cms: {
    appearance: "مظهر",
    location: "موقع",
    profile: "مظهر جانبي",
    seo: "سيو",
    page: "صفحة",
    account: "حساب",
    security: "حماية",
    billings: "الفواتير",
    custom_image: "فيديو مخصص",
    maximum: "أقصى",
    choose_another: "اختر آخر",
    select_font: "حدد الخط",
    rounded_corners: "زوايا مدورة",
    circle: "دائرة",
    straight_corners: "زوايا مستقيمة",
    outline: "الخطوط العريضة",
    button_background_color: "لون خلفية الزر",
    timer_digit_color: "لون أرقام الموقت",
    timer_background_color: "لون خلفية الموقت",
    button_font_color: "لون خط الزر",
    outline_style: "نمط المخطط التفصيلي",
    outline_width: "عرض المخطط التفصيلي",
    corners: "الزوايا",
    full_rounded_corners: "زوايا مدورة كاملة",
    insert_graph_image: "أدخل صورة الرسم البياني",
    enble_block_search_engine_indexing: "تمكين فهرسة محرك البحث",
    page_title_required: "عنوان الصفحة مطلوب",
    meta_description_required: "الوصف التعريفي مطلوب",
    branding_url_required: "عنوان URL للعلامة التجارية مطلوب",
    enter_title: "أدخل العنوان",
    enter_url: "إدخال عنوان الموقع",
    enter_meta_description: "أدخل وصف التعريف",
    enter_page_title: "أدخل عنوان الصفحة",
    enter_alt_text: "أدخل النص البديل",
    hours: "ساعات",
    minutes: "دقائق",
    seconds: "ثواني",
    scan_qr_code: "مسح رمز الاستجابة السريعة",
    cancel: "يلغي",
    you_sure_want_to_logout: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    previous: "سابق",
    next: "التالي",
  },
  appearance: {
    background_cap: "معرفتي",
    background: "معرفتي",
    favicon_cap: "فافيكون",
    favicon: "فافيكون",
    fonts_cap: "الخطوط",
    fonts: "الخطوط",
    seo_cap: "سيو",
    seo: "سيو",
    avatar_cap: "الصورة الرمزية",
    avatar: "الصورة الرمزية",
    link_cap: "الروابط",
    link: "الروابط",
    branding_cap: "العلامات التجارية",
    branding: "العلامات التجارية",
  },

  descriptions: {
    shorten_urls:
      ".قم بتقصير عناوين URL وإنشاء صفحات الارتباط الحيوي ورموز QR المخصصة وروابط vcard وروابط الملفات والمزيد",
    seo_setting: "إعدادات تحسين محركات البحث",
    update_checkout: "التحديث والاستمرار في الخروج الذهبي",
    plans_management: "إدارة الخطط",
    create_plan: "إنشاء خطة",
    fill: "املأ تفاصيل الفواتير الخاصة بك",
    handling:
      "نطلب تفاصيل الفواتير الخاصة بك لإنشاء فواتير مناسبة وللتعامل مع الضرائب ، قم بتقديم تفاصيل فواتير صالحة فقط.",
    no_account: "ليس لديك حساب؟",
    leave_empty: ".اتركه فارغا للحصول على واحد عشوائي",
    do_everything: "فعل كل شيء",
    with_one: "مع واحد",
    platform: "برنامج",
    get_started: "البدء",
    create_own:
      ".قم بإنشاء صفحة الارتباط الحيوي الفريدة والقابلة للتخصيص بدرجة كبيرة بسهولة",
    custom_colors: "ألوان وعلامات تجارية مخصصة",
    ready_to_use: "مكونات متعددة جاهزة للاستخدام",
    protection: "حماية كلمة المرور ، تحذير المحتوى الحساس",
    shortened_links: "روابط مختصرة",
    service: "نعم! يمكنك استخدام خدمتنا كمقصّر أيضًا.",
    demographic: "استهداف البلد والجهاز واللغة",
    scheduling: "الجدولة وحدود انتهاء الصلاحية",
    ab_rotation: "دوران أ / ب",
    password: "حماية كلمة المرور ، تحذير المحتوى الحساس",
    fully_featured:
      ".نظام مولد رمز الاستجابة السريعة متميز تمامًا مع قوالب سهلة الاستخدام",
    built_in: "تحليلات مدمجة",
    day_by:
      ".التحليلات اليومية والإحالات والبلدان وأنظمة التشغيل واللغات وغيرها الكثير",
    generate_links:
      ".إنشاء روابط ديناميكية للملفات والاستفادة من ميزات التتبع والحماية والبكسل وانتهاء الصلاحية",
    generate_vcard:
      ".إنشاء روابط vcard ديناميكية لبطاقة جهة الاتصال القابلة للتنزيل والاستفادة من التتبع ، ميزات الحماية والبكسل وانتهاء الصلاحية",
    offering: ".نقدم لك أيضًا مجموعة من 35 من أدوات الويب المفيدة كمكافأة",
    connect:
      "قم بتوصيل المجال الخاص بك أو استخدم المجالات المحددة مسبقًا الخاصة بنا",
    easiest_way: ".أسهل طريقة لتصنيف الموارد المدارة الخاصة بك",
    choose_yourself: ".اختر واحصل على ما تحتاجه بالضبط",
    feel_free: "لا تتردد في الاتصال بنا",
    enter_message: ".أدخل رسالتك هنا",
    add_new: "إضافة كتلة جديدة",
    add_link: "أضف زر ارتباط",
    add_heading: "أضف عنوانًا",
    add_tweet: "أضف تغريدة",
    add_avatar: "أضف الصورة الرمزية",
    add_social: "أضف الروابط الاجتماعية",
    choose_custom_plan: "ابدأ الخطة الذهبية",
    almost_there: "أنت على وشك الوصول إلى هناك ، بدون قيود.",
    trial_start: "ابدأ الإصدار التجريبي لمدة 7 أيام",
    skip_trial: "تخطي التجربة",
    trial_info:
      "من خلال الاستمرار في طلبك ، فإنك تؤكد أنك قرأت وفهمت ووافقت على الشروط والأحكام وسياسة الخصوصية الخاصة بالموقع.",
    terms: "الأحكام والشروط",
    add_image: "أضف صورة",
    img_description: ".وصف الصورة لأغراض الوصول وتحسين محركات البحث",
    add_youtube: "أضف فيديو يوتيوب",
    paste_video_url:
      ".الصق عنوان URL لفيديو YouTube الخاص بك وسنعرضه كفيديو في ملفك الشخصي",
    add_tiktok: "أضف فيديو TikTok",
    paste_tiktok: ".الصق عنوان URL لفيديو TikTok وسنعرضه كفيديو في ملفك الشخصي",
    tiktok_url: "رابط فيديو TikTok",
    valid_email: "يجب أن يكون البريد الإلكتروني عنوان بريد إلكتروني صالحًا",
    email_required: "البريد الالكتروني مطلوب",
    password_required: "كلمة المرور مطلوبة",
    name_required: "مطلوب اسم",
    user_name_required: "اسم المستخدم مطلوب",
    firstName_required: "الإسم الأول مطلوب",
    firstName_must_alphabets:
      "يجب أن يحتوي الاسم الأول على الحروف الهجائية فقط",
    lastName_must_alphabets:
      "يجب أن يحتوي الاسم الأخير على الحروف الهجائية فقط.",
    enter_email:
      ".يرجى إدخال عنوان البريد الإلكتروني المرتبط بحسابك وسنرسل لك عبر البريد الإلكتروني رابطًا لإعادة تعيين كلمه السر",
    already_account: "هل لديك حساب؟",
    drag_drop: "اسحب وأفلت لإعادة الترتيب",
    can_confirm: "أؤكد أنني قد قرأت وفهمت",
    of_site: ".من الجانب",
    confirm_password: "تأكيد كلمة المرور الجديدة",
    confirm_new: "تأكيد كلمة المرور مطلوب",
    least_characters: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
    must_match: "يجب ان تتطابق كلمات المرور",
    check_email: "من فضلك تفقد بريدك الالكتروني!",
    sent_code:
      "لقد أرسلنا عبر البريد الإلكتروني رمز تأكيد مكونًا من 6 أرقام إلى acb @ domain ، يرجى إدخال الرمز في المربع أدناه للتحقق من البريد الإلكتروني",
    no_code: "ليس لديك رمز؟",
    code_required: "الرمز مطلوب",
    checking_email: "التحقق من البريد الإلكتروني للمستخدم",
    set_2fa: "إعداد المصادقة الثنائية",
    monthly_payment: "مدفوعات شهرية",
    field_required: " حقل مطلوب",
    entered_url: "عنوان URL الذي أدخلته غير صالح للتضمين",
    golden_plan: "الخطة الذهبية",
    plan_detail:
      "لقد أوشكت على الانتهاء ، أكمل النموذج التالي وقم بتسجيل الخروج.",
    payment_frequency: "تكرار دفع",
    annual_payments: "المدفوعات السنوية",
    lifetime_deal: "صفقة مدى الحياة",
    payment_method: "طريقة الدفع او السداد",
    payment_method_stripe: "الدفع عن طريق قطاع",
    scan_qr:
      "إذا كنت ترغب في تنشيط المصادقة الثنائية ، امسح رمز الاستجابة السريعة أو أدخل المفتاح السري في تطبيق Google Authenticator وأدخل OTP أو تخطي",
    scanned: "تحقق من بريدك الإلكتروني أو Google Authenticator بحثًا عن رمز",
    skip: "أو تخطي",
    copy_Qr: "انسخ المفتاح السري فهو سري",
    type_payment: "طريقة الدفع",
    stripe: "شريط",
    one_payment: "دفعة لمرة واحدة",
    recurring_payment: "دفع متكرر",
    order_summary: "ملخص الطلب",
    plan: "يخطط",
    golden: "ذهبي",
    frequency: "تكرار",
    monthly: "شهريا",
    type: "يكتب",
    one_time: "مره واحده",
    paid_with: "مدفوعة",
    pay_pal: "باي بال",
    price: "سعر",
    code_redeemable: "لدي رمز خصم / قابل للاسترداد",
    code: "شفرة",
    total: "المجموع",
    checkout: "الدفع",
    day: "كل ثلاثون يوم",
    billing: "الفواتير",
    choosen_plan: "الخطة المختارة",
    home: "الصفحة الرئيسية",
    one_product: "منتجات نهاية واحدة",
    month_update: "12 شهر التحديثات",
    month_support: "6 أشهر من الدعم",
    bio_pages: "25 صفحة بيولينك",
    bio_block: "10 كتل بيولينك",
    all_block: " جميع كتل",
    visitors: "الزائرين",
    page_views: "عرض الصفحة",
    short_link: "250 روابط مختصرة",
    file_link: "2 روابط الملفات",
    vcard_link: "2 روابط ",
    qr_code: "رمز الاستجابة السريعة",
    proj: "50 مشروع",
    pixel: "5 بكسل",
    custom_domain: "المجالات المخصصة",
    day_stat: "365 يومًا للاحتفاظ بالإحصاءات",
    global_domain: "المجالات العالمية الإضافية",
    back_half: "مخصص النصف الخلفي",
    deep_lnk: "ربط عميق",
    removable_brand: "العلامة التجارية القابلة للإزالة",
    custom_back: "الخلفيات المخصصة",
    custom_col: "ألوان العرف",
    defollow: "حلقة الوصل اتبع",
    leap_link: "رابط قفزة",
    seo_feature: "ميزات تحسين محركات البحث",
    extra_font: "خطوط اضافية",
    custome_css: "لغة تنسيق ويب حسب الطلب",
    custom_js: "شبيبة مخصصة",
    no_ad: "لا اعلانات",
    api_access: "وصول أبي ",
    showout_result: "عرض - من 0 نتيجة.",
    user_manag: "إدارةالمستخدم",
    user_logs: "سجلات المستخدمين",
    user_creat: "إنشاء مستخدم",
    user: "المستعمل",
    status: "حالة",
    applied_codes: "الرموز المطبقة",
    applied_taxes: "الضرائب المطبقة",
    detail: "تفاصيل",
    total_amount: "المبلغ الإجمالي",
    bulk_actions: "إجراءات جملة",
    hidden_demo: "مخفي في العرض",
    cant_undone: "لا يمكن التراجع عنه.",
    login_thisuser: "تسجيل الدخول باسم هذا المستخدم",
    loginmodal_detail1: "بتسجيل الدخول كمستخدم آخر ، سيتم تسجيل خروجك من",
    loginmodal_detail2: "الحساب الجاري وتسجيل الدخول بالكامل لهذا المستخدم.",
    show_result: "عرض 1-12 من أصل 12 نتيجة.",
    add_instagram: "أضف منشور الانستغرام",
    paste_instagram_url: "لصق عنوان url لمنشور الانستغرام",
    delete_block_des:
      ".سيتم حذف جميع البيانات المتعلقة بلوك الرابط الحيوي بالكامل. لا يمكن التراجع عن هذا الإجراء",
    duplicate_block_des: ".قم بتكرار هذا المورد بسهولة بنقرة زر واحدة",
    duplicate_block: "كتلة مكررة",
    delete_block: "حذف الكتلة",
    add_multiple_images: "إضافة صور متعددة",
    admin_privileges:
      "سيكون للمستخدمين الإداريين نفس الامتيازات التي تتمتع بها ، كن حذرًا!",
    change_passDetail: "اتركه فارغًا إذا كنت لا تريد تغيير كلمة مرور المستخدم!",
    new_pass: "كلمة السر الجديدة",
    repeat_pass: "اعد كلمة السر",
    block_search: "منع فهرسة محرك البحث",
    block_biolink: "منع صفحة biolink من فهرستها بواسطة محركات البحث.",
    change_page:
      "قم بتغيير عنوان الصفحة تمامًا إلى عنوان مخصص تقوم بتعيينه هنا.",
    custom_meta:
      "قم بتعيين وصف تعريف مخصص لصفحة biolink الخاصة بك لترتيب أفضل في محركات البحث.",
  },

  biolink_title: {
    edit: "تعديل",
    delete: "حذف",
    delete_cap: "حذف",
    save_cap: "يحفظ",
    add_cap_modal: "يضيف",
    view: "رأي",
    settings: "إعدادات",
    duplicate: "مكرر",
    your_link_is: "الرابط الخاص بك هو",
    copy_to_clipboard: "مقطع إلى الحافظة",
    copied: "نسخ",
    change_status: "تغيير الوضع",
    edit_user: "تحرير العضو",
    november: "شهر نوفمبر",
    maximum: "أقصى",
  },

  admin: {
    welcome: "مرحبًا بعودتك",
    biolink_pages: "صفحات Biolinks",
    pageviews_tracked: "مرات مشاهدة الصفحة التي تم تتبعها",
  },

  label: {
    view_user: "عرض المستخدم",
    user_id: "معرف المستخدم",
    privileges: "الامتيازات",
    timezone: "وحدة زمنية",
    Factor_authentication: "عامل_المصادقة",
    Factor_authentication_2: "عامل_المصادقة",
    Anti_code: "كود مكافحة التصيد",
    active: "نشيط",
    disabled: "عاجز",
    hidden: "مختفي",
    english: "الإنجليزية",
    arabic: "عربى",
    main_language: "اللغة الرئيسية",
    no: "رقم",
    api_key: "مفتاح API",
    total_logins: "إجمالي عمليات تسجيل الدخول",
    last_useragent: "آخر وكيل مستخدم",
    last_active: "آخر نشاط",
    country: "دولة",
    direct_signup: "تسجيل مباشر",
    source: "مصدر",
    trial_done: "انتهت المحاكمة",
    last_subid: "آخر معرف فرعي",
    last_payamount: "مبلغ الدفعة الأخيرة",
    last_payprocessor: "آخر معالج دفع",
    plan_expdate: "تاريخ انتهاء الخطة",
    free: "مجانا",
    update: "تحديث",
    change_password: "غير كلمة السر",
    enable_stripepay: "تفعيل شريط مدفوعات ",
    publishable_key: "مفتاح قابل للنشر",
    secret_key: "المفتاح السري",
    webhook_secret: "سر الويب هوك",
    webhook: "الويب هوك",
    more_detail: "للحصول على مزيد من التفاصيل حول بعض التكوينات المتاحة.",
    read_the: "إقرأ ال",
    documentation: "توثيق",
  },

  addBlock: {
    choose_avatar: "اختر الصورة الرمزية",
    essentials: "إلزامي",
    text: "نص",
    media: "وسائط",
    miscellaneous: "متنوع",
    addBlocks: "إضافة كتل",
    viewBlock: "إظهار الكتل",
    paymentDetails: "بيانات الدفع",
    renewal: "التجديد",
    inclusive_tax: "الضرائب المدرجة",
    apply: "تتقدم",
    plan: "يخطط",
    enter_coupon_code: "أدخل رمز القسيمة",
    set_up_your: "الإعداد الخاص بك",
    credit_debit_card: "بطاقة الائتمان/الخصم",
    card_number: "رقم البطاقة",
    card_number_is_required: "رقم البطاقة مطلوب",
    please_enter_valid_card_number: "الرجاء إدخال رقم بطاقة سارية المفعول",
    please_enter_valid_cvv_number: "الرجاء إدخال رمز CVV صالح",
    expiry_date_is_required: "مطلوب تاريخ انتهاء الصلاحية",
    expiry_date: "تاريخ الانتهاء",
    enter_valid_month: "أدخل شهر صالح",
    enter_valid_year: "أدخل سنة صالحة",
    expiry_date_valid_month_year: "أدخل تاريخ انتهاء صلاحية صالحًا",
    cvv_is_required: "مطلوب CVV",
    invalid_characters_in_name: "أحرف غير صالحة في الاسم",
    change: "التغييرات",
    renew_plan_automatically:
      "يتم تجديد الخطة تلقائيًا في نهاية كل شهر. إلغاء في أي وقت.",
    make_payment: "قم بالدفع",
    subscribe_start_customizing: "قم بالتسجيل وابدأ في التخصيص",
    your_biolink_now: "الرابط الحيوي الخاص بك الآن",
    year: "سنة",
    month: "شهر",
    annual: "سنوي",
    off: "يغلق",
    auto: "تلقائي",
    payment_successful: "الدفع بنجاح",
    enjoy: "يتمتع",
    using_premium_and_continue: "باستخدام قسط واستمر في الإبداع",
    exclusive_biolinks: " بيولينكس حصرية",
    page: "صفحة",
    account: "حساب",
    account_: "حساب",
    security: "حماية",
    billings: "الفواتير",
    setting: "إعدادات",
    page_name: "اسم الصفحة",
    update_your_page_name: "قم بتحديث اسم صفحتك لإنشاء هويتك الفريدة",
    save_changes: "حفظ التغييرات",
    page_name_cannot: "لا يمكن أن يحتوي اسم الصفحة على رموز",
    remove: "يزيل",
    personal_details: "تفاصيل شخصية",
    first_name_must_be_valid: "يجب أن يكون الاسم الأول اسمًا صالحًا",
    first_name_must_be_20_characters:
      "يجب أن يتكون الاسم الأول من 20 حرفًا على الأكثر",
    email_should_be_50_characters:
      "يجب أن يحتوي البريد الإلكتروني على 50 حرفًا على الأكثر",
    email_address_must_be_valid: "يجب أن يكون عنوان البريد الإلكتروني صالحًا",
    upload: "لرفع",
    choose_account_type: "اختر نوع الحساب",
    enter_country: "أدخل البلد",
    state_region: "الولاية/الإقليم",
    enter_state_region: "الولاية/الإقليم يدخل",
    enter_city: "أدخل المدينة",
    zip_code: "رمز بريدي",
    enter_zip_code: "أدخل الرمز البريدي",
    account_type_required: "نوع الحساب مطلوب",
    country_required: "البلد المطلوبة",
    State_region_required: "ولاية/المنطقة مطلوبة",
    city_required: "المدينة المطلوبة",
    zip_required: "الرمز البريدي مطلوب",
    image_smaller_than_3MB: "يجب أن يكون حجم الصورة أقل من 3 ميجابايت",
    please_select_picture: "الرجاء اختيار صورة",
    image_size_should_be_3mb:
      "يجب ألا يتجاوز حجم الصورة 3 ميجابايت. الملفات المسموح بها هي .jpeg و.png.",
    security_: "حماية",
    enter_password_twice:
      "أدخل كلمة المرور الجديدة مرتين لتغيير كلمة المرور الخاصة بك",
    new_password: "كلمة المرور الجديدة",
    password_must_8_characters: "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل",
    including_uppercase_letter:
      "تتضمن حرفًا كبيرًا واحدًا، وحرفًا صغيرًا واحدًا، وحرفًا خاصًا واحدًا، وقيمة رقمية واحدة",
    enter_new_password: "أدخل كلمة المرور الجديدة",
    confirm_password: "تأكيد كلمة المرور",
    password_confirmation_required: "مطلوب تأكيد كلمة المرور",
    passwords_not_match: "كلمة المرور غير مطابقة",
    enter_confirm_password: "أدخل تأكيد كلمة المرور",
    factor_authentication_description:
      "التطبيق وأدخل otp جوجل المصادقة قم بمسح رمز الاستجابة السريعة ضوئيًا أو أدخل المفتاح السري فيه إذا كنت تريد تمكين المصادقة الثنائية",
    choose_plan_description: "اختر الخطة التي تناسب متطلباتك",
    billing_history: "تاريخ الفواتير",
    date_joined: "تاريخ الانضمام",
    last_activity: "النشاط الاخير",
    annually: "سنويا",
    header: "رأس",
    add_header: "إضافة رأس",
    enter_page_name: "أدخل اسم الصفحة",
    enter_page_title: "أدخل عنوان الصفحة",
    pagename_required: "اسم الصفحة مطلوب",
    pagetitle_required: "عنوان الصفحة مطلوب",
    contact_required: "الاتصال مطلوب",
    edit_header: "تحرير الرأس",
    whatapp_required: "مطلوب واتس اب",
    whatapp: "واتس اب",
    profile_alignment: "محاذاة الملف الشخصي",
    left: "غادر",
    center: "مركز",
    right: "يمين",
    want_to_set_background_image: "تريد تعيين صورة الخلفية",
    avatar_size: "حجم الصورة الرمزية",
    avatar_shape: "الشكل الرمزي",
    avatar_outline: "الخطوط العريضة للصورة الرمزية",
  },

  enter: "يدخل",
  media: "وسائط",
  link_URL_must_start: "يجب أن يبدأ عنوان URL للرابط بـ http: // أو https: //",
  link_icon_required: "كود الارتباط مطلوب",
  link_url_required: "رابط URL مطلوب",
  link_is_required: "عنوان الارتباط مطلوب",
  add_icon: "إضافة رمز",
  enter_link: "أدخل الارتباط",
  enter_link_title: "أدخل عنوان الارتباط",
  custom_link: "روابط مخصصة",
  add_image_grid: "أضف شبكة صور",
  header_required: "العنوان مطلوب",
  enter_header: "أدخل العنوان",
  header_size: "حجم العنوان",
  header_: "عنوان",
  question_required: "السؤال مطلوب",
  answer_required: "الجواب المطلوب",
  enter_answer: "أدخل الجواب",
  enter_question: "أدخل السؤال",
  choose_time: "اختر الوقت",
  choose_date: "اختر تاريخًا",
  drop_your_img: "قم بإسقاط صورتك هنا أو",
  browse_image: "تصفح الصورة",
  save: "يحفظ",
  components: "عناصر",
  privacy_policy: "سياسة الخصوصية",
  views: "الآراء",
  terms_here: "شروط الخدمة الخاصة بك تذهب هنا",
  bold: "بالخط العريض",
  italic: "مائل",
  underline: "تسطير",
  policy_here: "سياسة الخصوصية الخاصة بك اذهب هنا",
  overview: "نظرة عامة",
  needed_docs:
    "في هذه الصفحة ، يمكنك العثور على الوثائق المطلوبة لتثبيت المنتج وتكوينه بشكل كامل",
  product_installation:
    "إجراء تثبيت المنتج مستقيم للأمام ولا يتطلب أي خاص / خارج مهمة عادية. الحد الأدنى من المعرفة حول كيفية العمل مع قاعدة بيانات وإدارة الملفات على الخادم مطلوب.",
  created_on: "تم إنشاؤها على",
  requirements: "متطلبات",
  meet_req:
    "يرجى التأكد من أن الخادم الخاص بك يفي بالمتطلبات التالية قبل محاولة التثبيت أو الشراء المنتج.",
  december: "ديسمبر",
  payments: "المدفوعات",
  changelog_config:
    "تأكد من إعادة تكوين إعدادات خططك لتكوين المجالات الإضافية الجديدة",
  initial_release: "الإصدار الأولي",
  changelog_detail:
    "سيتم سرد كافة التحديثات الخاصة بـ Bil Bio هنا. تستند إصدارات Bil Bio إلى نظام MAJOR.MINOR.PATCH",
  get_support: "احصل على الدعم",
  official_website: "الموقع الرسمي",
  changelog: "التغيير",
  docs: "المستندات",
  read_documentation: "اقرأ التوثيق",
  read_changelog: "قراءة سجل التغيير",
  latest_users: "أحدث المستخدمين",
  page_views: "مشاهدات الصفحة",
  biolinks_pages: "بيولينكس الصفحات",
  percent_disc: "نسبة الخصم",
  fix_discount: "خصم على المبلغ الثابت",
  percent_amount: "كمية النسبة المئوية",
  duration: "مدة",
  find_me:
    "أقوم ببناء برامج عالية الجودة وجاهزة للاستخدام وبأسعار معقولة. هنا يمكنك أن تجدني:",
  twitter_bilBio: "تويترBilBio",
  support_is: "الدعم",
  only: "فقط",
  done_codecanyon: "تم القيام به من خلال Codecanyon",
  email_form: "نموذج البريد الإلكتروني",
  comments: "تعليقات",
  section: "الجزء",
  once: "ذات مرة",
  forever: "إلى الأبد",
  repeating: "التكرار",
  number_ofmonths: "عدد الأشهر",
  months: "الشهور",
  discount_amount: "مقدار الخصم",
  availabe_plan: "كم يوما ستكون الخطة متاحة",
  discount_plan: "اختر خصمًا بين 1٪ و 99٪ للرمز",
  redeemable: "قابل للاسترداد",
  install_product: "كيف يتم تثبيت المنتج؟",
  update_product: "كيف يتم تحديث المنتج؟",
  customize_product: "كيفية تخصيص المنتج؟",
  edit_home: "تحرير المنزل",
  code_usage: "كم مرة يمكن استخدام الرمز",
  home_settings: "إعدادات المنزل",
  about_section: "حول إعدادات القسم",
  website_settings: "إعدادات الموقع",
  contact_settings: "إعدادات الاتصال",
  Biolink_Page: "صفحة بيولينك",
  Qr_code: "رموز QR",
  analytics: "التحليلات",
  personal: "شخصي",
  business: "اعمال",
  city: "مدينة",
  country: "دولة",
  province: "المحافظة",
  opengraph_image: "فتح صورة الرسم البياني",
  page_title: "عنوان الصفحة",
  meta_description: "ميتا الوصف",
  zip: "أَزِيز",
  countdown: "العد التنازلي",
  share: "شارك",
  resend_code: "أعد إرسال الرمز",
  register: "تسجيل",
  link: "اتصال",
  link_cap: "اتصال",
  instagram: "انستغرام",
  google: "غوغل",
  facebook: "فيسبوك",
  telephone: "هاتف",
  life_time: "حياة",
  linkedin: "ينكدين",
  pinterest: "بينتيريست",
  twitch: "تويتش",
  snapchat: "سناب شات",
  spotify: "سبوتيفي",
  twitter: "تويتر",
  username: "اسم االمستخدم",
  monthly: "شهريا",
  annual: "سنوي",
  tracking_pixels: "بكسل التتبع",
  tool: "أداة",
  block: "الكتلة",
  add: "يضيف",
  add_cap: "يضيف",
  short_url: "عنوان URL قصير",
  customization: "التخصيص",
  image_alt: "صورة بديلة",
  branding: "العلامات التجارية",
  create_code: "إنشاء كود",
  create_newCode: "أنشئ رمزًا جديدًا",
  youtube_url: "يوتيوب فيديو URL",
  instagram_url: "رابط مشاركة انستغرام",
  channel: "قناة",
  fonts: "الخطوط",
  submit: "إرسال",
  delete: "حذف",
  duplicate: "ينسخ",
  monochrome: "أحادي اللون",
  gradient: "الانحدار",
  destination_url: "عنوان url المقصود",
  custom: "العادة",
  themes: "الموضوعات",
  background: "معرفتي",
  simple_gradients: "تدرجات بسيطة",
  abstract_gradients: "تدرجات مجردة",
  custom_color: "لون مخصص",
  color: "اللون",
  colors: "الألوان",
  custom_image_video: "صورة / فيديو مخصص",
  favicon: "فافيكون",
  maximum: "يسمح بامتداد .png و .gif و .ico. 2 ميغا بايت كحد أقصى.",
  display: "عرض",
  name: "اسم",
  Unique_user_name: "اسم مستخدم فريد",

  firstName: "الاسم الأول",
  text_color: "لون الخط",
  default_branding:
    "اتركه فارغًا للحصول على العلامة التجارية الافتراضية للموقع.",
  size: "بحجم",
  shape: "شكل",
  border_radius: "نصف قطر الحدود",
  border_Style: "نمط الحدود",
  total: "المجموع",
  border_width: "عرض الحدود",
  border_color: "لون الحدود",
  border_style: "نمط الحدود",
  img_thumbnail: "صورة مصغرة",
  bg_color: "لون الخلفية",
  biolinks: "بيولينكس",
  biolink: "بيولينك",
  biolink_blocks: "كتل بيولينك",
  total_sales: "إجمالي المبيعات",
  total_earned: "إجمالي المكتسبة",
  links: "الروابط",
  links_statistics: "روابط الإحصاء",
  files: "الملفات",
  file: "ملف",
  statistics: "الإحصاء",
  card: "بطاقة",
  codes: "رموز",
  seo: "سيو",
  domains: "المجالات",
  create: "إنشاء ضريبة",
  copyright: "حقوق النشر",
  terms_of_service: "شروط الخدمة",
  who_are_we: "من نحن؟",
  all_rights_reserved: "كل الحقوق محفوظة",
  export_to: "تصدير الى",
  filter: "منقي",
  search: "بحث",
  search_by: "البحث عن طريق",
  status: "الحالة",
  project: "مشروع",
  type: "يكتب",
  order_type: "نوع الطلب",
  results_per_page: "النتائج لكل صفحة",
  your_custom_alias: "الاسم المستعار المخصص الخاص بك",
  mode: "الوضع",
  contrast: "التباين",
  direction: "اتجاه",
  layout: "تَخطِيط",
  presets: "الإعدادات المسبقة",
  stretch: "تمتد",
  fullscreen: "شاشة كاملة",
  exit: "خروج",
  tweet_id: "سقسقة معرف",
  tracked_reviews: "مرات مشاهدة الصفحة المتعقبة",
  pricing_plans: "خطط التسعير",
  address: "تبوك",
  phone: "هاتف",
  send_message: "أرسل رسالة",
  email: "البريد الإلكتروني",
  title: "لقب",
  subject: "موضوعات",
  heading: "عنوان",
  text_editor: "محرر النص",
  avatar: "الصورة الرمزية",
  socials: "الاجتماعية",
  image: "صورة",
  youtube: "موقع يوتيوب",
  secret_key: "المفتاح السري",
  authenticate: "المصادقة",
  auth_type: "نوع المصادقة",
  time_based: "على أساس الوقت",
  tiktok: "تيك توك",
  destination: "المكان المقصود",
  purchased_Plan_monthly: ".لقد اشتريت خطة شهرية",
  purchased_Plan_yearly: ".لقد اشتريت خطة سنوية.",
  purchased_Plan_lifetime: "لقد اشتريت خطة مدى الحياة",
  enjoy_your_plan: ".يرجى الاستمتاع بخطة حياتك",
  close: "قريب",
  want_to_update_plan_yearly_lifetime:
    "هل تريد تحديث خطتك سنويًا أم مدى الحياة؟",
  want_to_update_plan_lifetime: "هل تريد تحديث خطتك مدى الحياة؟",
  updating_plan: "تحديث الخطة",
  text: "نص",
  round: "دائري",
  rounded: "مدور",
  straight: "مستقيم",
  and: "و",
  or: "أو",
  oftheSite: "من الجانب",
  whatYouWillGet: "ما ستحصل عليه",
  home: "الصفحة الرئيسية",
  choose_plan: "اختر الخطة",
  choose_plan_cap: "اختر الخطة",
  solid: "صلب",
  dashed: "متقطع",
  double: "مزدوج",
  outset: "البداية",
  inset: "أقحم",
  infinite: "لانهائي",
  animation: "الرسوم المتحركة",
  animation_runs: "تشغيل الرسوم المتحركة",
  bounce: "وثب، ارتداد",
  tada: "تادا",
  wobble: "تمايل",
  swing: "تأرجح",
  rubberband: "رابط مطاطي",
  pulse: "نبض",
  flash: "فلاش",
  bounce_in: "ترتد",
  fade_in: "اختفي",
  small: "صغير",
  medium: "متوسط",
  large: "كبير",
  email_address: "عنوان البريد الالكترونى",
  pass: "كلمه السر",
  forgot_password: "هل نسيت كلمة السر؟",
  forgot_desc: "لا تقلق! يحدث ذلك.",
  forgot_description: "الرجاء إدخال عنوان البريد الإلكتروني المرتبط بحسابك.",
  login: "تسجيل الدخول",
  remember_me: "تذكرنى",
  faq: "التعليمات",
  social: "تناسلي",
  send_request: "ارسل طلب",
  back: "الى الخلف",
  dashboard: "لوحة القيادة",
  plans: "الخطط",
  taxes: "الضرائب",

  languages: "اللغات",
  language_code: "رمز اللغة",
  powered_by: "مشغل بواسطة",
  verify: "تحقق",
  divider: "مقسم",
  add_divider: "إضافة مقسم",
  image_grid: "شبكة الصورة",
  yes: "نعم",
  janurary: "كانون الثاني",
  feb: "شهر فبراير",
  codes_management: "إدارة الرموز",
  create_tax: "إنشاء ضريبة",
  redeemed: "افتدى",
  quantity: "كمية",
  discount: "تخفيض",
  tax: "ضريبة",
  billing_for: "الفواتير ل",
  taxes_management: "إدارة الضرائب",
  random_discription: "وصف عشوائي لرسوم الدعم.",
  personal_business: "الشخصية والتجارية",
  exclusive: "حصرية",
  support_fee: "رسوم الدعم",
  call_to_action: "دعوة للعمل",
  language: "لغة",
  extensions: "ملحقات",
  database: "قاعدة البيانات",
  server: "الخادم",
  other_extentions:
    "ضع في اعتبارك ، قد تكون هناك حاجة لملحقات أخرى غير تلك المذكورة هنا ، مثل هذه تفترض المتطلبات أنك تعمل على خادم لائق ومحدث يجب أن يحتوي على الأساسيات المطلوبة ملحقات تعمل بالفعل.",
  users: "المستخدمين",
  add_plan: "أضف خطة",
  interval_count: "عدد الفترات",
  interval: "فترة",
  trial_days: "أيام المحاكمة",
  year: "سنة",
  month: "شهر",
  user_id: "معرف المستخدم",
  currency: "عملة",

  countries: {
    afghanistan: "🇦🇫 أفغانستان",
    aland_islands: "🇦🇽 جزر آلاند",
    albania: "🇦🇱 ألبانيا",
    algeria: "🇩🇿 الجزائر",
    american_samoa: "🇦🇸 ساموا الأمريكية",
    andorra: "🇦🇩 أندورا",
    angola: "🇦🇴 أنغولا",
    anguilla: "🇦🇮 أنغيلا",
    antarctica: "🇦🇶 القارة القطبية الجنوبية",
    antigua_barbuda: "🇦🇬 أنتيغوا وبربودا",
    argentina: "🇦🇷 الأرجنتين",
    armenia: "🇦🇲 أرمينيا",
    aruba: "🇦🇼 أروبا",
    australia: "🇦🇺 استراليا",
    austria: "🇦🇹 النمسا",
    azerbaijan: "🇦🇿 أذربيجان",
    bahamas: "🇧🇸 جزر البهاما",
    bahrain: "🇧🇭 البحرين",
    bangladesh: "🇧🇩 بنجلاديش",
    barbados: "🇧🇧 بربادوس",
    belarus: "🇧🇾 بيلاروسيا",
    belgium: "🇧🇪 بلجيكا",
    belize: "🇧🇿 بليز",
    benin: "🇧🇯 بنين",
    bermuda: "🇧🇲 برمودا",
    bhutan: "🇧🇹 بوتان",
    bolivia: "🇧🇴 بوليفيا",
    eustatius_saba: "🇧🇶 بونير وسانت يوستاتيوس وسابا",
    bosnia_herzegovina: "🇧🇦 البوسنة والهرسك",
    botswana: "🇧🇼 بوتسوانا",
    bouvet_island: "🇧🇻 جزيرة بوفيت",
    brazil: "🇧🇷 البرازيل",
    british_indian: "🇮🇴 إقليم المحيط الهندي البريطاني",
    brunei_darussalam: "🇧🇳 بروناي دار السلام",
    bulgaria: "🇧🇬 بلغاريا",
    burkina_faso: "🇧🇫 بوركينا فاسو",
    burundi: "🇧🇮 بوروندي",
    cambodia: "🇰🇭 كمبوديا",
    cameroon: "🇨🇲 الكاميرون",
    canada: "🇨🇦 كندا",
    cape_verde: "🇨🇻 الرأس الأخضر",
    cayman_islands: "🇰🇾 جزر كايمان",
    central_african: "🇨🇫 جمهورية إفريقيا الوسطى",
    chad: "🇹🇩 تشاد",
    chile: "🇨🇱 تشيلي",
    china: "🇨🇳 الصين",
    christmas_island: "🇨🇽 جزيرة الكريسماس",
    cocos_islands: "🇨🇨 جزر كوكوس (كيلينغ)",
    colombia: "🇨🇴 كولومبيا",
    comoros: "🇰🇲 جزر القمر",
    congo: "🇨🇬 الكونغو",
    democratic_republic: "🇨🇩 الكونغو ، جمهورية الكونغو الديمقراطية",
    cook_islands: "🇨🇰 جزر كوك",
    costa_rica: "🇨🇷 كوستاريكا",
    cote_ivoire: "🇨🇮 ساحل العاج",
    croatia: "🇭🇷 كرواتيا",
    cuba: "🇨🇺 كوبا",
    curacao: "🇨🇼 كوراكاو",
    cyprus: "🇨🇾 قبرص",
    czech_republic: "🇨🇿 جمهورية التشيك",
    denmark: "🇩🇰 الدنمارك",
    djibouti: "🇩🇯 جيبوتي",
    dominica: "🇩🇲 دومينيكا",
    dominican_republic: "🇩🇴 جمهورية الدومينيكان",
    ecuador: "🇪🇨 الاكوادور",
    egypt: "🇪🇬 مصر",
    el_salvador: "🇸🇻 السلفادور",
    equatorial_guinea: "🇬🇶 غينيا الاستوائية",
    eritrea: "🇪🇷 إريتريا",
    estonia: "🇪🇪 استونيا",
    ethiopia: "🇪🇹 إثيوبيا",
    falkland_islands: "🇫🇰 جزر فوكلاند (مالفيناس)",
    faroe_islands: "🇫🇴 جزر فارو",
    fiji: "🇫🇯 فيجي",
    finland: "🇫🇮 فنلندا",
    france: "🇫🇷 فرنسا",
    french_guiana: "🇬🇫 غيانا الفرنسية",
    french_polynesia: "🇵🇫 بولينيزيا الفرنسية",
    southern_territories: "🇹🇫 الأقاليم الجنوبية الفرنسية",
    gabon: "🇬🇦 الجابون",
    gambia: "🇬🇲 غامبيا",
    georgia: "🇬🇪 جورجيا",
    germany: "🇩🇪 ألمانيا",
    ghana: "🇬🇭 غانا",
    gibraltar: "🇬🇮 جبل طارق",
    greece: "🇬🇷 اليونان",
    greenland: "🇬🇱 جرينلاند",
    grenada: "🇬🇩 غرينادا",
    guadeloupe: "🇬🇵 جوادلوب",
    guam: "🇬🇺 غوام",
    guatemala: "🇬🇹 غواتيمالا",
    guernsey: "🇬🇬 جيرنزي",
    guinea: "🇬🇳 غينيا",
    guinea_bissau: "🇬🇼 غينيا بيساو",
    guyana: "🇬🇾 غيانا",
    haiti: "🇭🇹 هايتي",
    heard_island: "🇭🇲 جزيرة هيرد وجزر ماكدونالد",
    holy_see: "🇻🇦 الكرسي الرسولي (دولة الفاتيكان)",
    honduras: "🇭🇳 هندوراس",
    hong_kong: "🇭🇰 هونج كونج",
    hungary: "🇭🇺 المجر",
    iceland: "🇮🇸 آيسلندا",
    india: "🇮🇳 الهند",
    indonesia: "🇮🇩 اندونيسيا",
    iran_islamic: "🇮🇷 إيران ، جمهورية - الإسلامية",
    iraq: "🇮🇶 العراق",
    ireland: "🇮🇪 أيرلندا",
    isle_man: "🇮🇲 جزيرة مان",
    israel: "🇮🇱 إسرائيل",
    italy: "🇮🇹 ايطاليا",
    jamaica: "🇯🇲 جامايكا",
    japan: "🇯🇵 اليابان",
    jersey: "🇯🇪 جيرسي",
    jordan: "🇯🇴 الاردن",
    kazakhstan: "🇰🇿 كازاخستان",
    kenya: "🇰🇪 كينيا",
    kiribati: "🇰🇮 كيريباتي",
    korea_democratic: "🇰🇵 جمهورية كوريا الديمقراطية الشعبية",
    korea_republic: "🇰🇷 جمهورية كوريا",
    kosovo: "🇽🇰 كوسوفو",
    kuwait: "🇰🇼 الكويت",
    kyrgyzstan: "🇰🇬 قيرغيزستان",
    lao_people: "🇱🇦 جمهورية لاو الديمقراطية الشعبية",
    latvia: "🇱🇻 لاتفيا",
    lebanon: "🇱🇧 لبنان",
    lesotho: "🇱🇸 ليسوتو",
    liberia: "🇱🇷 ليبيريا",
    libyan_arab: "🇱🇾 الجماهيرية العربية الليبية",
    liechtenstein: "🇱🇮 ليختنشتاين",
    lithuania: "🇱🇹 ليتوانيا",
    luxembourg: "🇱🇺 لوكسمبورغ",
    macao: "🇲🇴 ماكاو",
    macedonia_former: "^ مقدونيا ، جمهورية يوغوسلافيا السابقة",
    madagascar: "🇲🇬 مدغشقر",
    malawi: "🇲🇼 ملاوي",
    malaysia: "🇲🇾 ماليزيا",
    maldives: "🇲🇻 جزر المالديف",
    mali: "🇲🇱 مالي",
    malta: "🇲🇹 مالطا",
    marshall_islands: "🇲🇭 جزر مارشال",
    martinique: "🇲🇶 مارتينيك",
    mauritania: "🇲🇷 موريتانيا",
    mauritius: "🇲🇺 موريشيوس",
    mayotte: "🇾🇹 مايوت",
    mexico: "🇲🇽 المكسيك",
    micronesia_federated: "🇫🇲 ولايات ميكرونيزيا الموحدة",
    moldova_republic: "🇲🇩 مولدوفا ، جمهورية",
    monaco: "🇲🇨 موناكو",
    mongolia: "🇲🇳 منغوليا",
    montenegro: "🇲🇪 الجبل الأسود",
    montserrat: "🇲🇸 مونتسيرات",
    morocco: "🇲🇦 المغرب",
    mozambique: "🇲🇿 موزمبيق",
    myanmar: "🇲🇲 ميانمار",
    namibia: "🇳🇦 ناميبيا",
    nauru: "🇳🇷 ناورو",
    nepal: "🇳🇵 نيبال",
    netherlands: "🇳🇱 هولندا",
    netherlands_antilles: "🇦🇳 جزر الأنتيل الهولندية",
    new_caledonia: "🇳🇨 كاليدونيا الجديدة",
    new_zealand: "🇳🇿 نيوزيلندا",
    nicaragua: "🇳🇮 نيكاراغوا",
    niger: "🇳🇪 النيجر",
    nigeria: "🇳🇬 نيجيريا",
    niue: "🇳🇺 نيوي",
    norfolk_island: "🇳🇫 جزيرة نورفولك",
    northern_mariana: "🇲🇵 جزر ماريانا الشمالية",
    norway: "🇳🇴 النرويج",
    oman: "🇴🇲 عمان",
    pakistan: "🇵🇰 باكستان",
    palau: "🇵🇼 بالاو",
    palestinian_territory: "🇵🇸 الأراضي الفلسطينية المحتلة",
    panama: "🇵🇦 بنما",
    papua_new: "🇵🇬 بابوا غينيا الجديدة",
    paraguay: "🇵🇾 باراغواي",
    peru: "🇵🇪 بيرو",
    philippines: "🇵🇭 الفلبين",
    pitcairn: "🇵🇳 بيتكيرن",
    poland: "🇵🇱 بولندا",
    portugal: "🇵🇹 البرتغال",
    puerto_rico: "🇵🇷 بورتوريكو",
    qatar: "🇶🇦 قطر",
    reunion: "🇷🇪 ريونيون",
    romania: "🇷🇴 رومانيا",
    russian_federation: "🇷🇺 الاتحاد الروسي",
    rwanda: "🇷🇼 رواندا",
    saint_barthelemy: "🇧🇱 القديس بارتيليمي",
    saint_helena: "🇸🇭 سانت هيلانة",
    saint_kitts: "🇰🇳 سانت كيتس ونيفيس",
    saint_lucia: "🇱🇨 سانت لوسيا",
    saint_martin: "🇲🇫 سانت مارتن",
    saint_pierre: "🇵🇲 سان بيير وميكلون",
    saint_vincent: "🇻🇨 سانت فنسنت وجزر غرينادين",
    samoa: "🇼🇸 ساموا",
    san_marino: "🇸🇲 سان مارينو",
    sao_tome: "🇸🇹 ساو تومي وبرينسيبي",
    saudi_arabia: "🇸🇦 السعودية",
    senegal: "🇸🇳 السنغال",
    serbia: "🇷🇸 صربيا",
    serbia_montenegro: "🇨🇸 صربيا والجبل الأسود",
    seychelles: "🇸🇨 سيشيل",
    sierra_leone: "🇸🇱 سيراليون",
    singapore: "🇸🇬 سنغافورة",
    sint_maarten: "🇸🇽 سينت مارتن",
    slovakia: "🇸🇰 سلوفاكيا",
    slovenia: "🇸🇮 سلوفينيا",
    solomon_islands: "🇸🇧 جزر سليمان",
    somalia: "🇸🇴 الصومال",
    south_africa: "🇿🇦 جنوب افريقيا",
    south_georgia: "🇬🇸 جورجيا الجنوبية وجزر ساندويتش الجنوبية",
    south_sudan: "🇸🇸 جنوب السودان",
    spain: "🇪🇸 اسبانيا",
    sri_lanka: "🇱🇰 سري لانكا",
    sudan: "🇸🇩 السودان",
    suriname: "🇸🇷 سورينام",
    svalbard_jan: "🇸🇯 سفالبارد وجان ماين",
    swaziland: "🇸🇿 سوازيلاند",
    sweden: "🇸🇪 السويد",
    switzerland: "🇨🇭 سويسرا",
    syrian_arab: "🇸🇾 الجمهورية العربية السورية",
    taiwan_province: "🇹🇼 تايوان ، مقاطعة الصين",
    tajikistan: "🇹🇯 طاجيكستان",
    tanzania_united: "🇹🇿 جمهورية تنزانيا المتحدة",
    thailand: "🇹🇭 تايلاند",
    timor_leste: "🇹🇱 تيمور الشرقية",
    togo: "🇹🇬 توغو",
    tokelau: "🇹🇰 توكيلاو",
    tonga: "🇹🇴 تونغا",
    trinidad_tobago: "🇹🇹 ترينيداد وتوباغو",
    tunisia: "🇹🇳 تونس",
    turkey: "🇹🇷 تركيا",
    turkmenistan: "🇹🇲 تركمانستان",
    turks_caicos: "🇹🇨 جزر تركس وكايكوس",
    tuvalu: "🇹🇻 توفالو",
    uganda: "🇺🇬 أوغندا",
    ukraine: "🇺🇦 أوكرانيا",
    united_arab: "🇦🇪 الإمارات العربية المتحدة",
    united_kingdom: "🇬🇧 المملكة المتحدة",
    united_states: "🇺🇸 الولايات المتحدة",
    unitedStates_minor: "🇺🇲 جزر الولايات المتحدة البعيدة الصغيرة",
    uruguay: "🇺🇾 أوروغواي",
    uzbekistan: "🇺🇿 أوزبكستان",
    vanuatu: "🇻🇺 فانواتو",
    venezuela: "🇻🇪 فنزويلا",
    viet_nam: "🇻🇳 فيتنام",
    virgin_islands: "🇻🇬 جزر فيرجن البريطانية",
    islands_us: "🇻🇮 جزر فيرجن ، الولايات المتحدة.",
    wallis_futuna: "🇼🇫 واليس وفوتونا",
    western_sahara: "🇪🇭 الصحراء الغربية",
    yemen: "🇾🇪 اليمن",
    zambia: "🇿🇲 زامبيا",
    zimbabwe: "🇿🇼 زيمبابوي",
  },

  miscellaneous: {
    tweel_url: "إضافة رابط تغريدة",
    divider: "مقسم",
    divider_cap: "مقسم",
    add_share: "إضافة كتلة حصة",
    add_countdown: "أضف مؤقتًا للعد التنازلي",
    edit_countdown: "تحرير العد التنازلي",
    enter_countdown_description: "أدخل وصف العد التنازلي",
    date_time: "التاريخ والوقت",
    add_action: "أضف العمل",
    add_faq: "أضف الأسئلة المتداولة",
    email_me: "راسلني",
    bulk_generator: "مولد بالجملة",
  },

  edit_taxes: {
    create_new: "إنشاء ضريبة جديدة",
    created_tax:
      "بمجرد إنشاء ضريبة ، لا يمكن تعديلها أو حذفها. بعد إنشاء الضريبة ، يمكنك إقرانها بخططك التي أنشأتها.",
    percentage: "نسبة مئوية",
    taxes: "الضرائب",
    edittax: "تحرير الضريبة",
    edit: "يحرر",
    ADD: "يضيف",
    edit_cap: "يحرر",
    description: "وصف",
    tax_value: "قيمة الضريبة",
    value_type: "نوع القيمة",
    fixed: "مُثَبَّت",
    inclusive: "شامل",
    exclusive: "حصرية",
    personal_only: "شخصي فقط",
    business_only: "العمل فقط",
    personal_business: "عمل شخصي",
    billing_for: "الفواتير ل",
    countries: "بلدان",
    select:
      "حدد البلدان التي تريد تطبيق هذه الضريبة عليها. اتركه فارغًا إذا كنت تريد تطبيق الضريبة على جميع البلدان.",
  },

  planss: {
    edit_plan: "تحرير الخطة",
    plan_features: "ميزات الخطة",
    set: "تعيين",
    for_unlimited: "تعيين -1 لعدد غير محدود",
    total_amoutpage:
      "العدد الإجمالي لصفحات الارتباط البيولوجي التي يمكن للمستخدم إنشاؤها.",
    total_shortlink:
      "العدد الإجمالي للروابط المختصرة التي يمكن للمستخدم إنشاؤها.",
    total_filelink:
      "المقدار الإجمالي لارتباطات الملفات التي يمكن للمستخدم إنشاؤها.",
    vcard_Limit: "Vcard حد الروابط",
    totl_vcard: "العدد الإجمالي لروابط vcard التي يمكن للمستخدم إنشاؤها.",
    total_eventlinks:
      "العدد الإجمالي لروابط الأحداث التي يمكن للمستخدم إنشاؤها.",
    total_domain:
      "المبلغ الإجمالي للمجالات المخصصة التي يمكن للمستخدم إضافتها.",
    link_state: "كم يوما سيتم الاحتفاظ بإحصائيات الروابط في قاعدة البيانات.",
    enable_blocks: "كتل Biolink الممكّنة",
    select_blocks:
      "حدد كتل صفحات biolink التي تم تمكينها للاستخدام في هذه الخطة.",
    state_retention: "الاحتفاظ بإحصائيات الروابط (أيام)",
    custom_domain: "حد المجالات المخصصة",
    event_limit: "روابط الأحداث الحد",
    file_limit: "حد روابط الملفات",
    link_limit: "حد الروابط",
    blocks_limit: "كتل Biolink لكل صفحة biolink حد",
    biolink_limit: "حدود Biolinks",
    qr_limit: "حدود رموز QR",
    pixels_limits: "حدود البكسل",
    project_limits: "حدود المشروع",
    additional_block: "المجالات العالمية الإضافية",
    additional_blockDes:
      "سيؤدي تمكين هذا إلى جعل جميع الأشخاص الذين لديهم هذه الخطة قادرين على استخدام جميع المجالات العالمية الإضافية.",
    back_half: "نصف خلفي مخصص",
    back_halfDes:
      "سيؤدي تمكين هذا إلى منح المستخدمين القدرة على الحصول على عناوين URL مستعارة مخصصة بدلاً من تلك التي يتم إنشاؤها تلقائيًا.",
    deep_link: "روابط عميقة",
    deep_linkDes:
      "سيؤدي تمكين هذا إلى منح المستخدم القدرة على استخدام روابط عميقة للإشارة إلى تطبيقات معينة بدلاً من عناوين URL http و https فقط.",
    enable_ad:
      "سيؤدي تمكين هذا إلى جعل جميع الأشخاص الذين لديهم هذه الخطة لا يرون أي إعلانات",
    remove_brand: "العلامة التجارية للتذييل القابل للإزالة",
    remove_brandDes:
      "يمنح هذا الخيار للأشخاص لإزالة العلامة التجارية من تذييل الروابط البيولوجية.",
    button_url: "عنوان URL لزر الاتصال",
    description: "عنوان URL لزر الاتصال",
    phone_collector: "جامع الهاتف",
    email_collector: "جامع البريد الإلكتروني",
    paragraph: "فقرة",
    custom_branding: "العلامة التجارية المخصصة للتذييل",
    custom_brandingDes:
      "يمنح هذا الخيار للأشخاص لإضافة علامتهم التجارية المخصصة لتذييل الروابط البيولوجية.",
    colored_links: "روابط ملونة",
    colored_linksDes: "يمنح المستخدم القدرة على تخصيص لون روابطه البيولوجية",
    advanced_statistics: "إحصائيات متقدمة",
    check_stat:
      "يمنح المستخدم القدرة على التحقق من إحصائيات العمق واختيار الإطار الزمني ",
    custom_backgrounds: "الخلفيات المخصصة",
    custom_backgroundDes:
      "يمنح المستخدم القدرة على إضافة خلفيات مخصصة على صفحات الروابط البيولوجية الخاصة بهم (الألوان والتدرجات والصور الفعلية).",
    temporary_URL: "URL مؤقت",
    temporary_urlDes:
      "يمنح المستخدم القدرة على جدولة الروابط والحد من النقرات.",
    seo_des:
      "يمنح المستخدم القدرة على تغيير العنوان والوصف التعريفي لصفحات Biolink",
    utm_des:
      "يمنح المستخدم القدرة على تعيين معلمات UTM العالمية لجميع الروابط داخل صفحة Biolink.",
    fonts_des:
      "يمنح المستخدم القدرة على اختيار الخط الذي يرضيه من قائمة الخطوط الإضافية.",
    password_protection: "حماية كلمة المرور",
    password_protectionDes:
      "يمنح المستخدم القدرة على حماية روابطهم بكلمة مرور.",
    sensitive_content: "تحذير بشأن المحتوى الحساس",
    sensitive_contentDes:
      "يمنح المستخدم القدرة على تمكين تحذير المحتوى الحساس على الروابط الخاصة بهم.",
    leap_linkDes:
      "يمنح المستخدم القدرة على إعادة توجيه صفحات الارتباط البيولوجي مؤقتًا إلى عنوان URL معين.",
    dofollow_link: "Dofollow روابط biolink",
    dofollow_linkDes:
      "سيكون لروابط المستخدم biolink خاصية dofollow ، وإلا فسيتم تعيينها على nofollow افتراضيًا.",
    rest_api: "تمكين قدرة المستخدم على استخدام REST API.",
    customcss_des:
      "تمكين القدرة على إضافة css مخصص لكل صفحة biolink. كن على علم للسماح للأشخاص الموثوق بهم فقط باستخدام هذه الميزة.",
    customjs_des:
      "تمكين القدرة على إضافة js مخصصة لكل vcard. كن على علم للسماح للأشخاص الموثوق بهم فقط باستخدام هذه الميزة.",
    product_name: "اسم المنتج",
    order: "ترتيب",
    plan_name: "اسم الخطة",
    action: "عمل",
  },

  filtermodal: {
    all: "الجميع",
    unconfirmed: "غير مؤكد",
    admin_created: "تم إنشاء المسؤول",
    admin_api: "تم إنشاء واجهة برمجة تطبيقات المشرف",
    facebook_login: "تسجيل الدخول الى الفيسبوك",
    twitter_login: "تويتر تسجيل الدخول",
    discord_login: "تسجيل الدخول على الفتنة",
    google_login: "تسجيل الدخول إلى Google",
    registration_date: "تاريخ التسجيل",
    ascending: "تصاعدي",
    descending: "تنازلي",
    ten: "٢",
    twentyfive: "٣",
    fifty: "٥",
    hundred: "٧",
    twohundred: "١٠",
    fivehundred: "٢٠",
    filters: "المرشحات",
    order_by: "ترتيب حسب",
    results_page: "النتائج لكل صفحة",
    created_datetime: "تاريخ الإنشاء",
    redeemable: "قابل للاسترداد",
    dayss: "أيام",
    external_payment: "معرف الدفع الخارجي",
    paid: "مدفوع",
    pending: "قيد الانتظار",
    offline_payment: "الدفع دون اتصال بالإنترنت",
    coinbase: "كوين بيس",
    payU: "PayU",
    paystack: "Paystack",
    razorpay: "رازورباي",
    mollie: "مولي",
    yookassa: "يوكاسا",
    crypto: "Crypto.com",
    paddle: "مجداف",
    monthly_payments: "مدفوعات شهرية",
    missing_translation:
      "الترجمة المفقودة: admin_payments.filters.order_by_name",
    missing_translate:
      "الترجمة المفقودة: admin_payments.filters.order_by_email",
  },

  location: {
    addpin: "إضافة دبوس",
    cancel_adding_pin: "إلغاء إضافة دبوس",
    adress: "العنوان",
    adress_placeholder: "123 الشارع الرئيسي، المدينة",
    phone: "هاتف",
    phone_placeholder: "١٢٣-٤٥٦-٧٨٩٠",
    add_location: "أضف الموقع",
    set_primary: "تعيين كأساسي",
    primary_location: "الموقع الرئيسي",
    get_directions: "احصل على الاتجاهات",
    added_any_location: "لم تقم بإضافة أي موقع",
    adress_title_caps: "إضافة عنوان العنوان",
    adress_details_caps: "إضافة تفاصيل العنوان",
    enter_location_name: "أدخل اسم الموقع",
    enter_location_adress: "أدخل عنوان الموقع",
    enter_location_phone: "أدخل هاتف الموقع",
    set_default_location:
      "قم بتعيين هذا الموقع باعتباره الموقع الرئيسي/الافتراضي",
    home: "بيت",
  },
  report: {
    report_abuse: "بلغ عن سوء معاملة",
    page_url: "رابط الصفحة",
    enter_page_url: "أدخل رابط الصفحة الذي يتم الإبلاغ عنه",
    report_type: "نوع التقرير",
    reporter_type: "نوع المراسل",
    additional_comment: "تعليق اضافي",
    attachment: "مرفق",
    select_report_type: " حدد نوع التقرير",
    spam_scam_phishing: "البريد العشوائي أو الاحتيال أو التصيد الاحتيالي",
    adult_content: "محتوى للبالغين",
    illegal_goods_services: "السلع والخدمات غير القانونية",
    fraud: "احتيال",
    child_abuse: "أساءةالأطفال",
    shocking_violent_content: "محتوى صادم أو عنيف",
    privacy_impersonation_harassment: "التحرش بانتحال الشخصية",
    gambling: "القمار",
    select_reporter_type: "اختر نوع المراسل",
    bil_bio_user: "المستخدم الحيوي",
    non_bil_bio_user: "مستخدم غير حيوي",
    legal_representative: "الممثل القانوني",
    law_enforcement: "تطبيق القانون",
    regulatory_body: "الهيئة التنظيمية",
    type_report_required: "نوع التقرير مطلوب",
    type_reporter_required: "نوع المراسل مطلوب",
    comment_required: "التعليق مطلوب",
    url_required: "عنوان URL للصفحة مطلوب",
    attachment_required: "المرفق مطلوب",
    attachment_paragraph: "قم بسحب وإسقاط الملف هنا أو تصفح.",
    report_sentence:
      "باستخدام هذا النموذج يمكنك الإبلاغ عن أي إساءة استخدام للسيرة الذاتية",
    site_protected: "هذا الموقع محمي بواسطة reCAPTCHA وGoogle",
    apply: "يتقدم",
    your_submission_received: "تم استلام تقريركم!",
    you_will_contacted: "سيتم لإتصال بك عند اللزوم.",
    go_home: "اذهب للمنزل",
  },
  language_setting: {
    language_cap: "لغة",
    update_with_unique_identity: "قم بتحديث اسم صفحتك لإنشاء هويتك الفريدة",
    added_languge: "اللغة المضافة",
    more_lang_cap: "إضافة المزيد من اللغة",
    english: "إنجليزي",
    arabic: "عربي",
    sidebar_language: "لغة",
    french: "فرنسي",
    chinese: "صينى",
    vietnamese: "الفيتنامية",
    search_other_lang: "بحث لغة أخرى",
    english_default: "الإنجليزية (الافتراضي)",
  },
  want_to_delete: "هل أنت متأكد أنك تريد حذف هذا؟",
  get_started_now: "ابدأ الآن",
  join_waiting_list: "انضم إلى قائمة الانتظار",
  package_suitable_people: "هذه الحزمة مناسبة للفرق من 1 إلى 15 شخصًا",
  we_use_cookies: "نحن نستخدم ملفات تعريف الارتباط",
  we_use_cookies_and_other_technologies:
    "نحن نستخدم ملفات تعريف الارتباط وتقنيات تتبع أخرى لتحسين تجربتك في تصفح موقعنا، وعرض محتوى مخصص وإعلانات مستهدفة، وتحليل حركة زوار موقعنا، وفهم مصدر زوارنا.",
  customize: "تخصيص",
  reject_all: "رفض الكل",
  accept_all: "قبول الكل",
  cookies_preference_center: "مركز تفضيلات ملفات تعريف الارتباط",
  select_lang: "اختر لغة",
  your_privacy: "خصوصيتك",

  privacy_is_import: "خصوصيتك مهمة بالنسبة لنا",
  cookies_detailed_message:
    "ملفات تعريف الارتباط هي ملفات نصية صغيرة جدًا يتم تخزينها على جهاز الكمبيوتر الخاص بك عند زيارة أحد مواقع الويب. نحن نستخدم ملفات تعريف الارتباط لمجموعة متنوعة من الأغراض ولتعزيز تجربتك عبر الإنترنت على موقعنا (على سبيل المثال، لتذكر تفاصيل تسجيل الدخول إلى حسابك). يمكنك تغيير تفضيلاتك ورفض أنواع معينة من ملفات تعريف الارتباط ليتم تخزينها على جهاز الكمبيوتر الخاص بك أثناء تصفح موقعنا. يمكنك أيضًا إزالة أي ملفات تعريف ارتباط مخزنة بالفعل على جهاز الكمبيوتر الخاص بك، ولكن ضع في اعتبارك أن حذف ملفات تعريف الارتباط قد يمنعك من استخدام أجزاء من موقعنا.",
  always_active: "دائما نشط",
  in_active: "غير نشط",
  active: 'نشط',
  cookies_consent: "موافقة ملفات تعريف الارتباط بواسطة",
  terms_feed: "شروط التغذية",
  save_my_preferences: "حفظ تفضيلاتي",
  privacy_title: "خصوصيتك مهمة بالنسبة لنا",
  privacy_content: "ملفات تعريف الارتباط هي ملفات نصية صغيرة جدًا يتم تخزينها على جهاز الكمبيوتر الخاص بك عند زيارة موقع الويب. نستخدم ملفات تعريف الارتباط لأغراض متنوعة ولتعزيز تجربتك عبر الإنترنت على موقعنا الإلكتروني (على سبيل المثال، لتذكر تفاصيل تسجيل الدخول إلى حسابك). يمكنك تغيير تفضيلاتك ورفض أنواع معينة من ملفات تعريف الارتباط ليتم تخزينها على جهاز الكمبيوتر الخاص بك أثناء تصفح موقعنا. يمكنك أيضًا إزالة أي ملفات تعريف ارتباط مخزنة بالفعل على جهاز الكمبيوتر الخاص بك، ولكن تذكر أن حذف ملفات تعريف الارتباط قد يمنعك من استخدام أجزاء من موقعنا الإلكتروني.",
  strictly_necessary_title: "ملفات تعريف الارتباط الضرورية للغاية",
  strictly_necessary_content: "هذه الملفات ضرورية لتزويدك بالخدمات المتاحة من خلال موقعنا الإلكتروني وتمكينك من استخدام ميزات معينة على موقعنا. بدون هذه الملفات، لا يمكننا تقديم بعض الخدمات على موقعنا.",
  functionality_title: "ملفات تعريف الارتباط الوظيفية",
  functionality_content: "تُستخدم هذه الملفات لتزويدك بتجربة أكثر تخصيصًا على موقعنا وتذكر الخيارات التي تقوم بها عند استخدام موقعنا. على سبيل المثال، قد نستخدم ملفات تعريف الارتباط الوظيفية لتذكر تفضيلات اللغة الخاصة بك أو تذكر تفاصيل تسجيل الدخول الخاصة بك.",
  tracking_title: "ملفات تعريف الارتباط التحليلية",
  tracking_content: "تُستخدم هذه الملفات لجمع المعلومات لتحليل حركة المرور إلى موقعنا وكيفية استخدام الزوار لموقعنا. على سبيل المثال، قد تتبع هذه الملفات أشياء مثل المدة التي تقضيها على الموقع أو الصفحات التي تزورها مما يساعدنا على فهم كيفية تحسين موقعنا من أجلك. المعلومات التي تم جمعها من خلال هذه الملفات لا تحدد هوية أي زائر فردي.",
  targeting_advertising_title: "ملفات تعريف الارتباط المستهدفة والإعلانية",
  targeting_advertising_content: "تُستخدم هذه الملفات لعرض الإعلانات التي من المحتمل أن تكون ذات أهمية لك بناءً على عادات التصفح الخاصة بك. قد تجمع هذه الملفات المعلومات التي جمعتها من موقعنا مع معلومات أخرى تم جمعها بشكل مستقل تتعلق بأنشطة متصفح الويب الخاص بك عبر شبكة مواقعهم الإلكترونية. إذا اخترت إزالة أو تعطيل هذه الملفات، فستظل ترى إعلانات ولكنها قد لا تكون ذات صلة بك.",
  more_info_title: "مزيد من المعلومات",
  more_info_content: "لأي استفسارات تتعلق بسياسة ملفات تعريف الارتباط لدينا واختياراتك، يرجى الاتصال بنا.",
  
  strict_necessary_cookies: 'ملفات تعريف الارتباط الضرورية للغاية',
  functionality_cookies: 'ملفات تعريف الارتباط الوظيفية',
  tracking_cookies: 'ملفات تعريف الارتباط التحليلية',
  targeting_cookies: 'ملفات تعريف الارتباط المستهدفة والإعلانية',
  more_info: 'مزيد من المعلومات',
  read_more: "اقرأ المزيد",
  read_less: "اقرأ أقل",

  user_analytics: {
    analytics: 'تحليلات',
    some_states: 'لنتحقق من بعض الإحصائيات اليوم!',
    feature_available: 'هذه الميزة متاحة فقط ل',
    pro_user: 'المستخدمين المحترفين',
    upgrade: 'الترقية إلى النسخة المحترفة',
    weak:'ضعيف',
    month:'شهر',
    year:'سنة',
    custom_duration:'مدة مخصصة',
    no_visitor:'عدد الزوار',
    no_clicks:'عدد النقرات',
    insta:'Instagram',
    twitter:'Twitter',
    youtube:'YouTube',
    linkedin:'LinkedIn',
    pinterest:'Pinterest',
    facebook:'Facebook',
    visitor_by_day:'الزوار حسب اليوم والوقت',
    sat: 'السبت',
    sun: 'الأحد',
    mon: 'الاثنين',
    tue: 'الثلاثاء',
    wed: 'الأربعاء',
    thu: 'الخميس',
    fri: 'الجمعة'
  },

   createPassword: {
    title: "أدخل كلمة المرور",
    description: "أدخل كلمة المرور لإكمال حسابك.",
    password: "كلمة المرور",
    enterPassword: "أدخل كلمة المرور",
    confirmPassword: "تأكيد كلمة المرور",
    enterConfirmPassword: "أدخل تأكيد كلمة المرور",
    accountAgreement: "عند إنشاء حساب، فإنك توافق على سياسة الخصوصية وشروط وأحكام الاستخدام لدينا.",
    createAccount: "إنشاء حساب",
    alreadyHaveAccount: "هل لديك حساب بالفعل؟",
    logIn: "تسجيل الدخول",
  },
  
  my_location: "موقعي",
  be_the_first_to: "كن أول من",
  bil_bio: "بيل.بيو",
  experience: "خبرة",
  waitlist_early_access: "سجل الآن للانضمام إلى قائمة الانتظار للوصول المبكر. كن جزءا من رحلتنا!",
  you_are_waitlist: "أنت على قائمة الانتظار!",
  thanks_joining_waitlist: "شكرا لانضمامك إلى قائمة الانتظار لدينا! ستكون من بين أول من يعلم عندما نقترب من إطلاق منصتنا الجديدة. ترقبوا التحديثات والرؤى الحصرية. نحن متحمسون لوجودك معنا!",
  main_title_part_one: "بناء رابط واحد",
  main_title_part_two: "لجميع الروابط الخاصة بك",
  no_blocks_found: "لم يتم العثور على كتل!",
  lorem_ipsum_dolor: "لوريم إيبسوم دولور سيت أميت، consectetur adipiscing إيليت. إيليت القول المأثور placerat urna iaculis",
};

export default ar;
